<ziro-top-nav [isHomePage]="true"></ziro-top-nav>
<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
<div [hidden]="isLoading" class="container-fluid pt-5">
  <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
    <div class="text-center pt-5">
      <div class="mb-5 pt-5">
        <img src="/static/img/ziro-platform.png" alt="ZIRO" class="home-page-logo" />
      </div>
      <div
        class="input-group input-group-has-icon"
        [ngClass]="{ 'has-feedback has-error': !!zpmSearchErrorMessage && !hideSearchErrorMessage }"
        [hidden]="!shouldShowSearchBar()"
      >
        <input
          #searchInput
          id="home-search-input"
          type="text"
          class="form-control input-group-icon-input form-control-lg input-text-start"
          [placeholder]="searchPlaceholder | translate"
          (keyup.enter)="searchByString()"
          [(ngModel)]="searchText"
          (ngModelChange)="updateSearchError()"
          data-automation="home-search-input"
        />
        <button class="btn btn-border btn-primary input-btn-end" type="button" (click)="searchByString()">
          <i [ngClass]="ziroIcons.SEARCH"></i>
        </button>
      </div>
      @if (zpmSearchErrorMessage && !hideSearchErrorMessage) {
        <div class="small has-error text-start" data-automation="zpm-search-error-message">
          {{ zpmSearchErrorMessage | translate }}
        </div>
      }

      <!-- Buttons -->
      <div class="top-buffer d-flex gap-2 justify-content-center">
        @if (isHosted && selectedTenant) {
          <!-- ZPM -->
          @if (isCreatingResourceAccountEnabled && isResourceAccountManagementAllowed()) {
            <a
              data-automation="resource-accounts-button"
              class="btn btn-border btn-outline-info"
              [routerLink]="['/resource-account-management', 'tenants', selectedTenant, 'resource-accounts']"
            >
              <i [ngClass]="ziroIcons.PHONE_LIST"></i>
              {{ 'tkey;home.resource_accounts.button' | translate }}
            </a>
          }
          @if (isCallQueueManagementAllowed()) {
            <a
              [routerLink]="['/call-queue-management/tenants', selectedTenant, 'teams-call-queues']"
              data-automation="list-call-queues-button"
              class="btn btn-border btn-outline-info"
            >
              <i [ngClass]="ziroIcons.CALL_QUEUE"></i>
              {{ 'tkey;home.list.call.queues.button' | translate }}
            </a>
          }
          @if (isEmergencyCallingManagementAllowed()) {
            <a
              [routerLink]="['/emergency-calling-management/tenants', selectedTenant]"
              data-automation="teams-emergency-calling-settings-button"
              class="btn btn-border btn-outline-info"
            >
              <i [ngClass]="ziroIcons.EMERGENCY_LOCATION_SMALL"></i>
              {{ 'tkey;home.list.emergency_calling.button' | translate }}
            </a>
          }
          @if (isAutoAttendantManagementAllowed()) {
            <a
              [routerLink]="['/auto-attendant-management/tenants', selectedTenant, 'teams-auto-attendants']"
              data-automation="teams-auto-attendants-button"
              class="btn btn-border btn-outline-info"
            >
              <i [ngClass]="ziroIcons.AUTO_ATTENDANT"></i>
              {{ 'tkey;home.list.auto_attendants.button' | translate }}

              <span
                class="badge bg-warning rounded-pill align-self-center mx-1 font-size-11"
                [attr.data-automation]="'beta-tag'"
              >
                <span>
                  {{ 'tkey;global.beta.text' | translate }}
                </span>
              </span>
            </a>
          }
        } @else if (!isHosted && isCucmEnabled && provisioningEnabled && !proxyServer) {
          <!-- ZPC -->
          @if (isAddUserEnabled && isAdminOrGlobalHelpdesk) {
            <a [routerLink]="'/user-add'" data-automation="add-user-button" class="btn btn-border btn-outline-info">
              <i [ngClass]="ziroIcons.USER"></i>
              {{ 'tkey;home.add.user.button' | translate }}
            </a>
          }
          @if (isDeskphoneEnabledOnAnyClusters) {
            <a
              [routerLink]="'/public-phone'"
              class="btn btn-border btn-outline-info"
              data-automation="add-public-phone-button"
            >
              <i [ngClass]="ziroIcons.DESKPHONE_SMALL"></i>
              {{ 'tkey;home.add.phone.button' | translate }}
            </a>
          }
        }
      </div>

      <!-- Links -->
      <div class="row">
        <div class="col-12">
          <div class="text-center muted small pt-4">
            @if (!isHosted) {
              <div>
                <strong>
                  <span>{{ 'tkey;home.version.text' | translate }}</span>
                </strong>
                <span data-automation="build-version">
                  {{ buildVersion }}
                </span>
              </div>
            } @else if (hasSupportSettingsPrivilege()) {
              <div>
                <strong>
                  <span>{{ 'tkey;home.build.timestamp.text' | translate }}</span>
                </strong>
                <span data-automation="build-timestamp">
                  {{ buildTimestamp }}
                </span>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="row top-buffer">
        <div class="col-md-12 text-center">
          <a data-automation="system-status-link" [routerLink]="'/system-health-status'" target="_blank">
            {{ 'tkey;system_status.title' | translate }}
          </a>
        </div>
        <div class="col-12">
          <div class="text-center muted small pt-1">
            @if (isHosted) {
              <div>
                <a id="home-hosted-link" href="{{ releaseNotesUrl }}" target="_blank">
                  {{ 'tkey;footer.release_notes' | translate }}
                  <i class="{{ ziroIcons.EXTERNAL_LINK }} release-notes-icon"></i>
                </a>
              </div>
            }
            @if (isAdminOrHelpdesk && showSupportLink) {
              <a id="home-support-link" [routerLink]="'/support'" target="_blank">
                {{ 'tkey;footer.support' | translate }}
              </a>
            }
            <p>
              <span
                [innerHtml]="'tkey;footer.copyright' | escapeHtml: { year: String(year) }"
                data-automation="copyright-stamp"
              ></span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
